'use strict';

import { Util } from '../../Common/Util';
import { AviaSearchModule } from './AviaModule/AviaSearchModule';

class Avia {
    constructor() {
        this._rootWrapper = $('.avia-search-module');
        this._lang = $('html').attr('lang');

        this._aviaSearchModule = new AviaSearchModule({
            page: this._rootWrapper,
            handler: this._searchTickets.bind(this),
            search: false,
        });
    }

    _searchTickets(event) {
        event.preventDefault();

        const cityFrom = this._aviaSearchModule._cityFrom.getSelectedCity();
        const cityTo = this._aviaSearchModule._cityTo.getSelectedCity();

        const startDate = this._aviaSearchModule._datePicker.getStartDate();
        const passengers = this._aviaSearchModule._passengers.getPassengersCount();

        const serviceClass = this._aviaSearchModule._serviceClass.getServiceClass();

        // Перевірка, чи cityFrom та cityTo валідні
        if (!cityFrom || !cityTo) {
            console.error('City from or city to is not selected.');
            return;
        }

        // Формування маршруту
        const route = `${Util.getLocalization()}avia/search/${cityFrom.name_en.replace(/ /g, '-').toLowerCase()}/${cityTo.name_en.replace(/ /g, '-').toLowerCase()}/${cityFrom.code.toLowerCase()}/${cityTo.code.toLowerCase()}/${cityFrom.id}/${cityTo.id}/${startDate}/${passengers.addults}/${passengers.children}/${passengers.baby}/${serviceClass.toLowerCase()}/`;
        window.location = route;
    }
}

$(() => {
    new Avia;
});